import React from 'react';
import { motion } from 'framer-motion';

const AnimatedBackground = () => {
  const particles = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: Math.random() * 4 + 2,
    duration: Math.random() * 20 + 10
  }));

  const networkNodes = Array.from({ length: 8 }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    y: Math.random() * 100,
    connections: Math.floor(Math.random() * 3) + 1
  }));

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-background to-secondary/5" />
      {/* Animated Particles */}
      {particles?.map((particle) => (
        <motion.div
          key={particle?.id}
          className="absolute rounded-full bg-primary/20"
          style={{
            left: `${particle?.x}%`,
            top: `${particle?.y}%`,
            width: `${particle?.size}px`,
            height: `${particle?.size}px`,
          }}
          animate={{
            y: [0, -30, 0],
            opacity: [0.2, 0.8, 0.2],
            scale: [1, 1.2, 1],
          }}
          transition={{
            duration: particle?.duration,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
      {/* Network Connections */}
      <svg className="absolute inset-0 w-full h-full">
        {networkNodes?.map((node, index) => (
          <g key={node?.id}>
            {/* Node */}
            <motion.circle
              cx={`${node?.x}%`}
              cy={`${node?.y}%`}
              r="3"
              fill="var(--color-accent)"
              opacity="0.6"
              animate={{
                r: [3, 5, 3],
                opacity: [0.6, 1, 0.6],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                delay: index * 0.5,
              }}
            />
            
            {/* Connections */}
            {index < networkNodes?.length - 1 && (
              <motion.line
                x1={`${node?.x}%`}
                y1={`${node?.y}%`}
                x2={`${networkNodes?.[index + 1]?.x}%`}
                y2={`${networkNodes?.[index + 1]?.y}%`}
                stroke="var(--color-accent)"
                strokeWidth="1"
                opacity="0.3"
                animate={{
                  opacity: [0.1, 0.5, 0.1],
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  delay: index * 0.3,
                }}
              />
            )}
          </g>
        ))}
      </svg>
      {/* Floating Geometric Shapes */}
      <motion.div
        className="absolute top-20 left-10 w-16 h-16 border-2 border-primary/30 rounded-lg"
        animate={{
          rotate: [0, 360],
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "linear",
        }}
      />
      <motion.div
        className="absolute bottom-32 right-16 w-12 h-12 bg-secondary/20 rounded-full"
        animate={{
          y: [0, -20, 0],
          x: [0, 10, 0],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      <motion.div
        className="absolute top-1/3 right-1/4 w-8 h-8 border-2 border-accent/40 rotate-45"
        animate={{
          rotate: [45, 405],
          opacity: [0.4, 0.8, 0.4],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
    </div>
  );
};

export default AnimatedBackground;